/**
 * Global GSAP + Lenis bootstrap.
 * Plain script (no bundler) — loaded via asset_url in theme.liquid AFTER
 * gsap.min.js, ScrollTrigger.min.js, DrawSVGPlugin.min.js and lenis.min.js.
 *
 * Owns the single Lenis instance so GSAP's ticker can drive it (autoRaf: false).
 * Per-section animation logic lives in its own [feature].js file, not here.
 */
(function () {
  if (window.__tamreGsapInit) return
  window.__tamreGsapInit = true

  gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin)

  // Mobile Safari/Chrome collapse & re-show the address bar as you scroll, which
  // resizes the viewport height and would otherwise fire a ScrollTrigger refresh —
  // remapping every scrub against the new height and snapping scroll-linked values
  // (e.g. the survey's colour inversion flashing on scroll-up). Ignore those UI-only
  // height changes; real resizes / orientation changes still refresh.
  ScrollTrigger.config({ ignoreMobileResize: true })

  // Single source of truth for smooth scroll. autoRaf:false so GSAP drives it.
  const lenis = new Lenis({ autoRaf: false, allowNestedScroll: true })
  window.lenis = lenis

  // Keep ScrollTrigger in sync with Lenis-driven scroll position.
  lenis.on('scroll', ScrollTrigger.update)
  gsap.ticker.add((time) => lenis.raf(time * 1000))
  gsap.ticker.lagSmoothing(0)

  // Web fonts change heading/line metrics that pinned ScrollTriggers measure —
  // recompute once they've settled so pins don't start from stale geometry.
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(() => ScrollTrigger.refresh())
  }
})()
